// src/App.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';

const App = () => (
  <div className="app">
    <Navbar />
    <main className="container">
      <Outlet />
    </main>
    <Footer />
  </div>
);

export default App;
